import { AlertTriangle } from "lucide-react";

export default function InterruptButton({ onClick, idle }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`btn-interrupt ${idle ? "idle-pulse" : ""}`}
      data-testid="interrupt-action-button"
    >
      <span className="flex items-center justify-center gap-3">
        <AlertTriangle className="w-6 h-6" />
        <span>Interrupted!</span>
      </span>
    </button>
  );
}
